var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[_c('div',{staticClass:"title"},[_vm._v("联系我们")]),_c('div',{staticClass:"container",domProps:{"innerHTML":_vm._s(_vm.conList)}})])}
var staticRenderFns = []

export { render, staticRenderFns }